/** @flow */
import toast from 'react-hot-toast'

const handleError = (error) => {
  let errorMessage = ''
  if (error) {
    const { data } = error
    if (typeof data !== 'object') {
      errorMessage = 'An error occurred, please try again'
    } else if (data.message) {
      if (data.errors && Array.isArray(data.errors)) {
        data.errors.map((item) => {
          errorMessage += `${item.message} \n`
        })
      } else {
        errorMessage = data.message
      }
    }
  } else {
    errorMessage = 'An error occurred, check your internet connection'
  }
  toast.error(errorMessage)
}

export default handleError
